import {ReactComponent as Checked} from './Checkbox-c.svg';
import {ReactComponent as UnChecked} from './Checkbox-u.svg';
import {useState} from "react";

export default ({value, active, name}) => {
    // const [active, setActive] = useState(false);
    return (
        <div style={{cursor: "pointer"}} className={active ? "checked" : "unChecked"} data-value={value} data-log={name}>
            {active ? <Checked/> : <UnChecked/>}
        </div>
    )
}
